module.exports = __webpack_public_path__ + "assets/img/solard-edge-veikimas.6626b14a.jpg";